import React, { useState } from 'react';
import { Menu, LogOut, Plus, Coins } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { logout } from '@/config/firebase';
import { toast } from 'sonner';
import SubscriptionDialog from '@/components/Subscription/SubscriptionDialog';

const Header = ({ onMenuClick, onLoginClick, showEmailBanner, emailBannerComponent }) => {
  const { currentUser, userProfile } = useAuth();
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      toast.success('Logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Failed to logout');
    }
  };

  return (
    <>
      <header className="fixed top-0 right-0 left-0 sm:left-24 bg-cyan-50 z-50">
        <div className="h-16 flex items-center justify-between px-4 sm:px-6">
          {/* Hamburger menu - only visible on very small screens */}
          <Button
            variant="ghost"
            size="icon"
            className="sm:hidden"
            onClick={onMenuClick}
            data-testid="hamburger-menu"
          >
            <Menu className="h-6 w-6" />
          </Button>

          <div className="flex-1" />

          <div className="flex items-center gap-4">
            {currentUser ? (
              <div className="flex items-center gap-3">
                {/* Credits Button */}
                <Button
                  onClick={() => setSubscriptionDialogOpen(true)}
                  variant="outline"
                  className="text-sm font-medium flex items-center gap-2"
                  data-testid="credits-button"
                >
                  <Coins className="h-4 w-4" />
                  {userProfile?.credits ?? 0} Credits
                  <Plus className="h-4 w-4" />
                </Button>
                
                {/* Logout Icon */}
                <Button
                  onClick={handleLogout}
                  variant="ghost"
                  size="icon"
                  className="h-9 w-9"
                  data-testid="logout-button"
                  title="Logout"
                >
                  <LogOut className="h-5 w-5" />
                </Button>
              </div>
            ) : (
              <Button
                onClick={onLoginClick}
                className="bg-gradient-to-r from-cyan-600 to-turquoise-600 hover:from-cyan-700 hover:to-turquoise-700 text-white"
              >
                Login / Sign Up
              </Button>
            )}
          </div>
        </div>
        
        {/* Email Verification Banner - renders at bottom of header */}
        {showEmailBanner && emailBannerComponent}
      </header>

      {/* Subscription Dialog */}
      <SubscriptionDialog
        open={subscriptionDialogOpen}
        onClose={() => setSubscriptionDialogOpen(false)}
        onSuccess={() => {
          setSubscriptionDialogOpen(false);
          toast.success('Subscription updated!');
        }}
      />
    </>
  );
};

export default Header;